module.exports = __webpack_public_path__ + "static/media/qr-baby.811f5193.png";